import type { App } from 'vue'
import { Icon } from './Icon'
import { Permission } from './Permission'
import { BaseButton } from './Button'
import { TMap } from './TMap'
import { BtnExport } from './BtnExport'
import { TableAction } from './TableAction'
import { Pagination } from './Pagination'
// import { UploadType } from './Upload'
import { SearchMenu } from './SearchMenu'
import { SelectMap } from './SelectMap'
import { CarBrandModel } from './CarBrandModel'
import { SelectStatus } from './SelectStatus'

export const setupGlobCom = (app: App<Element>): void => {
  app.component('Icon', Icon)
  app.component('Permission', Permission)
  app.component('BaseButton', BaseButton)
  app.component('TMap', TMap)
  app.component('BtnExport', BtnExport)
  app.component('TableAction', TableAction)
  app.component('Pagination', Pagination)
  app.component('SearchMenu', SearchMenu)
  app.component('SelectMap', SelectMap)
  app.component('CarBrandModel', CarBrandModel)
  app.component('SelectStatus', SelectStatus)
  // app.component('UploadType', UploadType)
}
